import { useContext } from "react";

import { EncryptionContext } from "./EncryptionProvider";

/**
 * Hook to access the EncryptionContext.
 *
 * @throws {Error} If used outside of EncryptionProvider
 * @returns {Object} The encryption context value containing encrypt function and refreshEncryptionToken
 */
export const useEncryption = () => {
  const context = useContext(EncryptionContext);

  return context;
};
